import React from 'react';
import RankListCo from '../RankListCo';
import { NewCountriesContextProps } from '../_type';

const MetricsRankListCo = (props: NewCountriesContextProps) => {
  const { config, data } = props || {};
  const { regionDataType, defaultRegionDataType, tabMsg } = data || {};

  return (
    <>
      <RankListCo
        regionDataType={defaultRegionDataType ? defaultRegionDataType : regionDataType}
        config={config}
        data={data}
        tabMsg={tabMsg}
      />
    </>
  );
};

export default MetricsRankListCo;
